import Vue from "vue";
import VueReact from "vue-react";
import { VuePlugin } from "vuera";
import { set } from "@8x8/oxygen-config";
import { labelNovo } from "@8x8/oxygen-constants";
import Button from "@8x8/oxygen-button";
import Input from "@8x8/oxygen-input";
import Checkbox from "@8x8/oxygen-checkbox";
import Label from "@8x8/oxygen-label";
import Select from "@8x8/oxygen-select";
import Textarea from "@8x8/oxygen-textarea";
import MilestoneTracker from "@8x8/oxygen-milestone-tracker";

import { Toaster } from "@8x8/oxygen-toaster";
import HomeIcon from "@8x8/oxygen-icon/icons/HomeIcon";
import GlobeIcon from "@8x8/oxygen-icon/icons/GlobeIcon";
import UserGroupsIcon from "@8x8/oxygen-icon/icons/UserGroupsIcon";
import SearchIcon from "@8x8/oxygen-icon/icons/SearchIcon";
import FeedbackIcon from "@8x8/oxygen-icon/icons/FeedbackIcon";
import ArrowDownIcon from "@8x8/oxygen-icon/icons/ArrowDownIcon";
import UserGroupsPlusIcon from "@8x8/oxygen-icon/icons/UserGroupsPlusIcon";
import UserIcon from "@8x8/oxygen-icon/icons/UserIcon";
import UserHostIcon from "@8x8/oxygen-icon/icons/UserHostIcon";
import EmailCircleIcon from "@8x8/oxygen-icon/icons/EmailCircleIcon";
import DeskPhoneIcon from "@8x8/oxygen-icon/icons/DeskPhoneIcon";
import TemplateIcon from "@8x8/oxygen-icon/icons/TemplateIcon";
import LeaveIcon from "@8x8/oxygen-icon/icons/LeaveIcon";
import CalendarAlternativeIcon from "@8x8/oxygen-icon/icons/CalendarAlternativeIcon";
import AttendantIcon from "@8x8/oxygen-icon/icons/AttendantIcon";
import ResetIcon from "@8x8/oxygen-icon/icons/ResetIcon";
import SurveyIcon from "@8x8/oxygen-icon/icons/SurveyIcon";
import PhoneWithStarIcon from "@8x8/oxygen-icon/icons/PhoneWithStarIcon";
import ViewDistanceIcon from "@8x8/oxygen-icon/icons/ViewDistanceIcon";
import CloseCircleIcon from "@8x8/oxygen-icon/icons/CloseCircleIcon";
import BarGraphHorizontalIcon from "@8x8/oxygen-icon/icons/BarGraphHorizontalIcon";
import EnvelopeCheckIcon from "@8x8/oxygen-icon/icons/EnvelopeCheckIcon";
import MinusCircleIcon from "@8x8/oxygen-icon/icons/MinusCircleIcon";
import PlusCircleIcon from "@8x8/oxygen-icon/icons/PlusCircleIcon";
import LockIcon from "@8x8/oxygen-icon/icons/LockIcon";
import RingGroupIcon from "@8x8/oxygen-icon/icons/RingGroupIcon";
import UserGroupsLineIcon from "@8x8/oxygen-icon/icons/UserGroupsLineIcon";
import BroomIcon from "@8x8/oxygen-icon/icons/BroomIcon";
import EvaluateIcon from "@8x8/oxygen-icon/icons/EvaluateIcon";
import ReRouteIcon from "@8x8/oxygen-icon/icons/ReRouteIcon";
import DatabaseIcon from "@8x8/oxygen-icon/icons/DatabaseIcon";
import AddressBookIcon from "@8x8/oxygen-icon/icons/AddressBookIcon";
import BullhornIcon from "@8x8/oxygen-icon/icons/BullhornIcon";
import LiveMonitorIcon from "@8x8/oxygen-icon/icons/LiveMonitorIcon";
import RefreshIcon from "@8x8/oxygen-icon/icons/RefreshIcon";
import EnvelopeExclamationIcon from "@8x8/oxygen-icon/icons/EnvelopeExclamationIcon";
import ExclamationSolidIcon from "@8x8/oxygen-icon/icons/ExclamationSolidIcon";
import TrashSolidIcon from "@8x8/oxygen-icon/icons/TrashSolidIcon";
import BestFitIcon from "@8x8/oxygen-icon/icons/BestFitIcon";
import PhoneWithStarSolidIcon from "@8x8/oxygen-icon/icons/PhoneWithStarSolidIcon";
import ExtensionSolidIcon from "@8x8/oxygen-icon/icons/ExtensionSolidIcon";
import DialpadIcon from "@8x8/oxygen-icon/icons/DialpadIcon";
import CloseIcon from "@8x8/oxygen-icon/icons/CloseIcon";
import ArrowRightIcon from "@8x8/oxygen-icon/icons/ArrowRightIcon";
import PlusSmallIcon from "@8x8/oxygen-icon/icons/PlusSmallIcon";
import NewTabIcon from "@8x8/oxygen-icon/icons/NewTabIcon";
import MinimizeIcon from "@8x8/oxygen-icon/icons/MinimizeIcon";
import ExpandIcon from "@8x8/oxygen-icon/icons/ExpandIcon";
import UploadIcon from "@8x8/oxygen-icon/icons/UploadIcon";
import DotsVerticalIcon from "@8x8/oxygen-icon/icons/DotsVerticalIcon";
import ShieldIcon from "@8x8/oxygen-icon/icons/ShieldIcon";
import InfoCircleSmallIcon from "@8x8/oxygen-icon/icons/InfoCircleSmallIcon";
import MessageIcon from "@8x8/oxygen-icon/icons/MessageIcon";
import LicenseIcon from "@8x8/oxygen-icon/icons/LicenseIcon";
import ChatCircleSolidIcon from "@8x8/oxygen-icon/icons/ChatCircleSolidIcon";
import CrownIcon from "@8x8/oxygen-icon/icons/CrownIcon";
import PhoneIcon from "@8x8/oxygen-icon/icons/PhoneIcon";
import EmailCircleSolidIcon from "@8x8/oxygen-icon/icons/EmailCircleSolidIcon";
import { IdentityManagementIcon } from "@8x8/oxygen-icon";

Vue.use(VuePlugin);

Vue.use(VueReact);

// icons
Vue.react("HomeIcon", HomeIcon);
Vue.react("GlobeIcon", GlobeIcon);
Vue.react("UserGroupsIcon", UserGroupsIcon);
Vue.react("UserIcon", UserIcon);
Vue.react("UserGroupsPlusIcon", UserGroupsPlusIcon);
Vue.react("EmailCircleIcon", EmailCircleIcon);
Vue.react("EnvelopeExclamationIcon", EnvelopeExclamationIcon);
Vue.react("ExclamationSolidIcon", ExclamationSolidIcon);
Vue.react("CloseCircleIcon", CloseCircleIcon);
Vue.react("LeaveIcon", LeaveIcon);
Vue.react("CalendarAlternativeIcon", CalendarAlternativeIcon);
Vue.react("UserHostIcon", UserHostIcon);
Vue.react("SearchIcon", SearchIcon);
Vue.react("FeedbackIcon", FeedbackIcon);
Vue.react("ArrowDownIcon", ArrowDownIcon);
Vue.react("DeskPhoneIcon", DeskPhoneIcon);
Vue.react("TemplateIcon", TemplateIcon);
Vue.react("AttendantIcon", AttendantIcon);
Vue.react("ResetIcon", ResetIcon);
Vue.react("SurveyIcon", SurveyIcon);
Vue.react("PhoneWithStarIcon", PhoneWithStarIcon);
Vue.react("PhoneWithStarSolidIcon", PhoneWithStarSolidIcon);
Vue.react("ExtensionSolidIcon", ExtensionSolidIcon);
Vue.react("ViewDistanceIcon", ViewDistanceIcon);
Vue.react("BarGraphHorizontalIcon", BarGraphHorizontalIcon);
Vue.react("EnvelopeCheckIcon", EnvelopeCheckIcon);
Vue.react("PlusCircleIcon", PlusCircleIcon);
Vue.react("MinusCircleIcon", MinusCircleIcon);
Vue.react("LockIcon", LockIcon);
Vue.react("RingGroupIcon", RingGroupIcon);
Vue.react("UserGroupsLineIcon", UserGroupsLineIcon);
Vue.react("BroomIcon", BroomIcon);
Vue.react("EvaluateIcon", EvaluateIcon);
Vue.react("ReRouteIcon", ReRouteIcon);
Vue.react("DatabaseIcon", DatabaseIcon);
Vue.react("AddressBookIcon", AddressBookIcon);
Vue.react("BullhornIcon", BullhornIcon);
Vue.react("LiveMonitorIcon", LiveMonitorIcon);
Vue.react("RefreshIcon", RefreshIcon);
Vue.react("TrashSolidIcon", TrashSolidIcon);
Vue.react("BestFitIcon", BestFitIcon);
Vue.react("DialpadIcon", DialpadIcon);
Vue.react("CloseIcon", CloseIcon);
Vue.react("ArrowRightIcon", ArrowRightIcon);
Vue.react("PlusSmallIcon", PlusSmallIcon);
Vue.react("NewTabIcon", NewTabIcon);
Vue.react("ExpandIcon", ExpandIcon);
Vue.react("MinimizeIcon", MinimizeIcon);
Vue.react("UploadIcon", UploadIcon);
Vue.react("DotsVerticalIcon", DotsVerticalIcon);
Vue.react("ShieldIcon", ShieldIcon);
Vue.react("InfoCircleSmallIcon", InfoCircleSmallIcon);
Vue.react("LicenseIcon", LicenseIcon);
Vue.react("ChatCircleSolidIcon", ChatCircleSolidIcon);
Vue.react("MessageIcon", MessageIcon);
Vue.react("CrownIcon", CrownIcon);
Vue.react("PhoneIcon", PhoneIcon);
Vue.react("EmailCircleSolidIcon", EmailCircleSolidIcon);

Vue.react("R-Select", Select);
Vue.react("R-Label", Label);
Vue.react("R-Input", Input);
Vue.react("R-Checkbox", Checkbox);
Vue.react("R-Button", Button);
Vue.react("R-Toaster", Toaster);
Vue.react("R-Textarea", Textarea);
Vue.react("R-MilestoneTracker", MilestoneTracker);
Vue.react("IdentityManagementIcon", IdentityManagementIcon);

set({
  label: {
    ...labelNovo,
    height: "24px",
  },
});
